import { getCookie } from "./use-cookie"

export function getBaseAPI() {
    const current = process.env.REACT_APP_ENV
    const commonAPI = process.env.REACT_APP_API_URL
    const cookieName =`enviroment_${current}`
    const selectedEnviroment =  getCookie(cookieName)

    if (selectedEnviroment !== null && 
        selectedEnviroment !== undefined && 
        selectedEnviroment !== ""  &&
        current !== "dev"
    ) {
        if(current === "production") {
            return `https://api-pdv.${selectedEnviroment}.nexaas.com`
        } else if(current === "homologation") {
            return `https://api-pdv.hml.${selectedEnviroment}.nexaas.com`
        } else {
            return `https://api-pdv.dev.${selectedEnviroment}.nexaas.com`
        }
    } 
    return commonAPI
}

export function getBaseAPIEstoka() {
    const current = process.env.REACT_APP_ENV
    const commonAPI = process.env.REACT_APP_ESTOKA_API_URL
    const cookieName =`enviroment_${current}`
    const selectedEnviroment =  getCookie(cookieName)


    if (selectedEnviroment !== null && 
        selectedEnviroment !== undefined && 
        selectedEnviroment !== "" &&
        current !== "dev"
    ) {
        if(current === "production") {
            return `https://api-oms.${selectedEnviroment}.nexaas.com`;
        } else if(current === "homologation") {
            return `https://api-oms.hml.${selectedEnviroment}.nexaas.com`;
        } else {
            return `https://api-oms.dev.${selectedEnviroment}.nexaas.com`;
        }
    } 
    return commonAPI
}


// WEBPACK FOOTER //
// ./src/util/get-base-api.js